import React from "react";
import "./cart-item.styles.scss";

interface CartItemProps {
  cartItem: {
    id: number;
    name: string;
    imageUrl: string;
    price: number;
    quantity: number;
  };
}

const CartItem: React.FC<CartItemProps> = ({ cartItem }) => {
  const {name, imageUrl, price, quantity } = cartItem;

  return (
    <div className="cart-item-container" data-testid="cart-item">
      <img src={imageUrl} alt={name} />
      <div className="item-details">
        <span className="name">{name}</span>
        <span className="price">
          {quantity} x ${price}
        </span>
      </div>
    </div>
  );
}

export default CartItem;
